<template>
  <div class="moneybag-page">
    <div class="moneybag-header">
      <button
        type="button"
        class="moneybag-back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <div class="moneybag-title">
        {{ $t('user.fundManage') }}
      </div>
    </div>

    <div class="moneybag-content">
      <section class="account-card">
        <span class="account-icon">
          <van-icon name="paid" />
        </span>
        <div class="amount-group">
          <span class="amount-label">
			  
            {{ $t('moneybag.account') }}
          </span>
          <strong>
            {{ utils_moneyMark() }} {{ formattedFunds }}
          </strong>
        </div>
        <div class="amount-group income-group">
          <span class="amount-label">
            {{ $t('shopCenter.trading') }}
            <!-- {{ $t('moneybag.todayIncome') }} -->
          </span>
          <strong>
            {{ utils_moneyMark() }} {{ data?.trading }}
            <!-- {{ formattedTodayIncome }} -->
          </strong>
        </div>
      </section>

      <section class="action-card">
        <button
          type="button"
          class="action-button withdraw-action"
          @click="$router.push('/cash')"
        >
          <span class="action-label">{{ $t('moneybag.withdraw') }}</span>
        </button>
        <button
          type="button"
          class="action-button recharge-action"
          @click="$router.push('/kefu')"
        >
          <span class="action-label">{{ $t('moneybag.recharge') }}</span>
        </button>
      </section>

      <section class="settings-card menu-card">
        <button
          v-for="item in menuItems"
          :key="item.label"
          type="button"
          class="setting-row"
          @click="$router.push(item.route)"
        >
          <span
            class="setting-icon"
            :class="item.tone"
          >
            <van-icon :name="item.icon" />
          </span>
          <span class="setting-label">{{ $t(item.label) }}</span>
          <van-icon
            name="arrow"
            class="row-arrow"
          />
        </button>
      </section>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import { Icon } from 'vant';

    Vue.use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
                data: null,
                funds: 0,
                todayIncome: 0,
                menuItems: [
                    { label: 'moneybag.financialCard', route: '/account', icon: 'credit-pay', tone: 'blue' },
                    // { label: 'moneybag.digitalWallet', route: '/account', icon: 'bag-o', tone: 'cyan' },
                    { label: 'moneybag.rechargeRecord', route: '/rechargeRecord', icon: 'description', tone: 'green' },
                    { label: 'moneybag.withdrawRecord', route: '/withdrawRecord', icon: 'records', tone: 'violet' },
                    { label: 'moneybag.todayDetails', route: '/funds', icon: 'orders-o', tone: 'gray' }
                ]
            };
        },
        computed: {
            formattedFunds() {
                return this.formatAmount(this.funds);
            },
            formattedTodayIncome() {
                return this.formatAmount(this.todayIncome);
            }
        },
        created() {
            this.$parent.footer('moneybag');
        },
        mounted() {
            this.fetchFunds();
        },
        methods: {
            fetchFunds() {
                Fetch('/user/funds').then(r => {
                    const data = r.data || {};
					this.data = data;
                    const list = Array.isArray(data.list) ? data.list : [];

                    this.funds = this.toAmount(data.money) + this.toAmount(data.wx_bankbz);
                    this.todayIncome = this.sumTodayIncome(list);
                });
            },
            sumTodayIncome(list) {
                let total = 0;

                list.forEach(item => {
                    if (item && String(item.type) === '1' && this.isToday(item.time)) {
                        total += this.toAmount(item.money);
                    }
                });

                return total;
            },
            isToday(time) {
                if (!time) {
                    return false;
                }

                const date = new Date(String(time).replace(/-/g, '/'));

                if (Number.isNaN(date.getTime())) {
                    return false;
                }

                const today = new Date();
                return date.getFullYear() === today.getFullYear()
                    && date.getMonth() === today.getMonth()
                    && date.getDate() === today.getDate();
            },
            toAmount(value) {
                const amount = parseFloat(value);
                return Number.isFinite(amount) ? amount : 0;
            },
            formatAmount(value) {
                const fixed = this.toAmount(value).toFixed(2);
                const parts = fixed.split('.');

                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

                return parts.join('.');
            }
        }
    };
</script>

<style lang="less" scoped>
    .moneybag-page {
        min-height: 100vh;
        padding-bottom: 18px;
        box-sizing: border-box;
        background: #f4f5fb;
        color: #061429;
    }

    .moneybag-header {
        position: sticky;
        top: 0;
        z-index: 10;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f8fd;
    }

    .moneybag-back {
        position: absolute;
        left: 18px;
        top: 15px;
        width: 28px;
        height: 28px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #071426;
        font-size: 22px;
    }

    .moneybag-title {
        height: 58px;
        color: #202637;
        font-size: 14px;
        font-weight: 500;
        line-height: 58px;
        text-align: center;
    }

    .moneybag-content {
        padding: 16px 16px 88px;
    }

    .account-card,
    .settings-card {
        overflow: hidden;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
    }

    .account-card {
        min-height: 112px;
        display: grid;
        grid-template-columns: 52px minmax(0, 1fr) minmax(0, 1fr);
        align-items: center;
        column-gap: 12px;
        padding: 18px 20px;
        box-sizing: border-box;
    }

    .account-icon {
        width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: linear-gradient(135deg, #ffbd61 0%, #ff8e2b 100%);
        color: #fff;
        font-size: 18px;
        box-shadow: 0 7px 16px rgba(255, 142, 43, .18);
    }

    .amount-group {
        min-width: 0;
    }

    .amount-label {
        display: block;
        overflow: hidden;
        color: #8b93a3;
        font-size: 12px;
        line-height: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .amount-group strong {
        display: block;
        margin-top: 5px;
        overflow: hidden;
        color: #050b18;
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .income-group {
        padding-left: 14px;
        border-left: 1px solid #edf0f6;
    }

    .settings-card {
        margin-top: 18px;
    }

    .action-card {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;
        margin-top: 24px;
    }

    .action-button {
        height: 50px;
        min-width: 0;
        padding: 0 12px;
        border: 0;
        border-radius: 9px;
        color: #fff;
        font-size: 14px;
        font-weight: 700;
        line-height: 50px;
        text-align: center;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .06);
        box-sizing: border-box;
    }

    .withdraw-action {
        background: linear-gradient(135deg, #ff1d25 0%, #ff141d 100%);
    }

    .recharge-action {
        background: linear-gradient(135deg, #ffd909 0%, #ff9a0b 100%);
    }

    .action-label {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .setting-row {
        min-height: 70px;
        display: grid;
        grid-template-columns: 36px minmax(0, 1fr) 16px;
        align-items: center;
        column-gap: 14px;
        width: calc(100% - 40px);
        margin: 0 20px;
        padding: 0;
        border: 0;
        border-bottom: 1px solid #edf0f6;
        background: #fff;
        color: #243049;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        box-sizing: border-box;
    }

    .setting-row:last-child {
        border-bottom: 0;
    }

    .setting-icon {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        color: #fff;
        font-size: 16px;
    }

    .setting-icon.blue {
        background: linear-gradient(135deg, #6199ff 0%, #246cf2 100%);
    }

    .setting-icon.red {
        background: linear-gradient(135deg, #ff6764 0%, #ff3346 100%);
    }

    .setting-icon.orange {
        background: linear-gradient(135deg, #ffbd61 0%, #ff8e2b 100%);
    }

    .setting-icon.cyan {
        background: linear-gradient(135deg, #42d7dc 0%, #17a8cc 100%);
    }

    .setting-icon.green {
        background: linear-gradient(135deg, #70d87b 0%, #2fac59 100%);
    }

    .setting-icon.violet {
        background: linear-gradient(135deg, #9a86ff 0%, #7662f7 100%);
    }

    .setting-icon.gray {
        background: linear-gradient(135deg, #a8b2c1 0%, #737f91 100%);
    }

    .setting-label {
        min-width: 0;
        overflow: hidden;
        color: #243049;
        font-size: 14px;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .row-arrow {
        color: #c4cad4;
        font-size: 16px;
    }
</style>
